const styles = {
  input: {
    mb: 2,

    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
  },
};

export default styles;
